import { withConfiguration } from "../../context/ConfigurationContext";
import { withSession } from "../../context";
import { addAccessTokenToLcmApiUrl, url } from "../../utils";
import { sessionShape } from "../../shapes";

type Props = {
  pictureUrl?: string;
  session: sessionShape;
  configuration: {
    lcmApiUrl?: string;
  };
};

export function ListItemImage({ pictureUrl, session, configuration }: Props) {
  const { lcmApiUrl } = configuration;
  const { token } = session;

  const imageUrl = addAccessTokenToLcmApiUrl(pictureUrl, lcmApiUrl, token);

  return (
    <div
      className="list-item-image-image"
      style={{
        backgroundImage: `url(${imageUrl}), url(${url("/images/no-picture.png")}`,
      }}
    />
  );
}

export default withConfiguration(withSession(ListItemImage));
